










import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component({
  name: 'SkillBar'
})
export default class SkillBar extends Vue {
  showLine: boolean

  @Prop({})
  enabled!: boolean

  @Prop({})
  name!: string

  @Prop({})
  value!: number

  constructor () {
    super()
    this.showLine = false
  }

  @Watch('enabled')
  onPropertyChanged (value: boolean, oldValue: boolean) {
    if (!oldValue && value) {
      setTimeout(() => {
        this.showLine = true
      }, 300)
    } else if (!value) {
      this.showLine = false
    }
  }

  get lineStyle () {
    return {
      width: this.showLine ? '100%' : '0%'
    }
  }

  get dotStyle () {
    return {
      left: this.showLine ? `${100*this.value}%` : '0%'
    }
  }
}
